/**
 * Hides specific elements on the page based on URL hash conditions.
 * 
 * @returns {Promise<void>} A promise that resolves once the elements are processed.
 */

export default async (): Promise<void> => {
    // Select elements from the DOM
    const tfAnchorsPlanning = document.querySelector("#tf-anchors-planning") as HTMLElement | null;
    const greenThing = document.querySelector("#green-thing") as HTMLElement | null;
    
    // Get the current URL hash, removing the '#' symbol
    const hashStr: string = window.location.hash.replace("#", "");

    // Exit early if the hash does not include 'activePrestations'
    if(!hashStr.includes('activePrestations')) return

    // If hash include 'activePrestations', hide elements
    if (tfAnchorsPlanning && tfAnchorsPlanning.parentElement)  tfAnchorsPlanning.parentElement.style.setProperty('display', 'none', 'important');
    if(greenThing) greenThing.style.setProperty('display', 'none', 'important');
};